// extracted by mini-css-extract-plugin
export default {"root":"styles_root__MykUF","box":"styles_box__zMPL-","errNum":"styles_errNum__iNWrH","button":"styles_button__vSnYB"};